import { RecentlyViewed } from '@theme/recently-viewed-products';

class RecentlyViewedProducts extends HTMLElement {
  #intersectionObserver = new IntersectionObserver(
    (entries, observer) => {
      if (!entries[0]?.isIntersecting) return;
      observer.disconnect();
      this.#loadProducts();
    },
    { rootMargin: '0px 0px 400px 0px' }
  );

  connectedCallback() {
    this.#intersectionObserver.observe(this);
  }

  disconnectedCallback() {
    this.#intersectionObserver.disconnect();
  }

  async #loadProducts() {
    const { url, sectionId, maxProducts, searchPerformed, productId } = this.dataset;
    const id = this.id;

    if (searchPerformed === 'true') {
      return;
    }

    let products = RecentlyViewed.getProducts();

    if (productId) {
      products = products.filter(pid => pid !== productId);
    }

    if (products.length === 0) {
      this.classList.add('hidden');
      return;
    }

    const max = parseInt(maxProducts) || 4;
    const query = products.slice(0, max).map(pid => `id:${pid}`).join(' OR ');

    const searchUrl = `${url}?q=${encodeURIComponent(query)}&type=product&section_id=${sectionId}`;

    try {
      const response = await fetch(searchUrl);
      if (!response.ok) {
        throw new Error(`Server returned ${response.status}`);
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const newElement = html.querySelector(`recently-viewed-products[id="${id}"]`);

      if (newElement?.innerHTML && newElement.innerHTML.trim().length) {
        this.dataset.searchPerformed = 'true';
        this.innerHTML = newElement.innerHTML;
      } else {
        this.classList.add('hidden');
      }
    } catch (error) {
      console.error('Recently viewed products error:', error.message);
      this.classList.add('hidden');
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
